import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
const ContactForm = () => {
  const form = useRef<HTMLFormElement>(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    success: false,
    message: '',
    loading: false
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormStatus({
      submitted: true,
      success: false,
      message: 'Sending your message...',
      loading: true
    });
    // Using EmailJS to send the form data
    emailjs.sendForm('service_km2wsak',
    // Replace with your EmailJS service ID
    'template_1bhls6b',
    // Replace with your EmailJS template ID
    form.current!, 's4Ejfert6BrFF0oek' // Replace with your EmailJS public key
    ).then(result => {
      console.log('Email sent successfully:', result.text);
      setFormStatus({
        submitted: true,
        success: true,
        message: 'Thank you for your message. We will get back to you shortly.',
        loading: false
      });
      // Reset form after successful submission
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    }, error => {
      console.error('Failed to send email:', error.text);
      setFormStatus({
        submitted: true,
        success: false,
        message: 'There was an error sending your message. Please try again later.',
        loading: false
      });
    });
  };
  return <div className="bg-white p-6 md:p-8 rounded-lg shadow-md" data-id="element-18">
      <h3 className="text-xl font-serif mb-6 text-[#1a2542]" data-id="element-19">
        Send Us a Message
      </h3>
      {formStatus.submitted && <div className={`mb-6 p-4 rounded ${formStatus.loading ? 'bg-blue-50 text-blue-800' : formStatus.success ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'}`} data-id="element-20">
          {formStatus.message}
        </div>}
      <form ref={form} onSubmit={handleSubmit} data-id="element-21">
        <div className="mb-4" data-id="element-22">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-23">
            Name
          </label>
          <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#c8a951] focus:border-transparent" data-id="element-24" />
        </div>
        <div className="mb-4" data-id="element-25">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-26">
            Email
          </label>
          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#c8a951] focus:border-transparent" data-id="element-27" />
        </div>
        <div className="mb-4" data-id="element-28">
          <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-29">
            Subject
          </label>
          <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#c8a951] focus:border-transparent" data-id="element-30" />
        </div>
        <div className="mb-6" data-id="element-31">
          <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-32">
            Message
          </label>
          <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#c8a951] focus:border-transparent" data-id="element-33" />
        </div>
        <button type="submit" disabled={formStatus.loading} className={`w-full bg-[#1a2542] hover:bg-[#233055] text-white py-3 rounded-md transition-colors duration-300 font-medium ${formStatus.loading ? 'opacity-70 cursor-not-allowed' : ''}`} data-id="element-34">
          {formStatus.loading ? 'Sending...' : 'Send Message'}
        </button>
      </form>
    </div>;
};
export default ContactForm;